<!-- @format -->

<div
	id="frequently-bought-together"
	class="frequently-bought-together background-base-subtle hmf-my-m hmf-mt-m-xl hmf-mb-l hmf-mb-m-xl hmf-overflow-x-auto">
	<div class="pdp-content-width hmf-mx-auto hmf-my-0 hmf-display-flex hmf-flex-column hmf-justify-content-between">
		<div class="hmf-py-m hmf-pt-m-xl hmf-px-lg-m hmf-py-m-xl">
			<div class="header-container hmf-w-100 hmf-mx-auto hmf-my-auto">
				<!-- HEADER SECTION -->
				<!-- title -->
				<div class="add-on-title hmf-text-align-center hmf-mx-auto">
					Frequently Bought Together
				</div>
				<!-- divider -->
				<div class="hmf-display-flex hmf-flex-wrap hmf-mx-0 hmf-justify-content-center">
					<div class="orange-line hmf-mt-xs"></div>
				</div>
			</div>
			<div class="hmf-h-100 hmf-w-100">
				<div class="hmf-grid hmf-justify-content-center hmf-display-flex hmf-mx-auto hmf-my-0">
					<div class="hmf-overflow-x-auto hmf-overflow-y-hidden hmf-px-xs-0 hmf-span-12 hmf-mt-m hmf-display-flex hmf-justify-content-m-center">
						<!-- card container -->
						<div class="cart-product-recommendation-card-container hmf-display-flex hmf-justify-content-sm-center hmf-mx-auto hmf-my-0 hmf-pt-s hmf-pb-xxxs">
							@for (product of products(); track product.imageLoaderConfig) {
								<div class="individual-card-container background-base dcsg-card hmf-soft-radius hmf-p-xxs hmf-p-m-xs hmf-display-flex hmf-flex-column hmf-justify-content-between hmf-align-items-stretch">
									@if (isFBTFavoriteButtonEnabled()) {
										<shared-favorites-components-auth-icon
											class="favorites-icon"
											[ecode]="product.skuDetails.parentPartNumber"
											[isAuthenticated]="isAuthenticated()"
											[favoritedECodes]="favoritedECodes()"
											[location]="FavoritesLocationEnum.FBT">
										</shared-favorites-components-auth-icon>
									}
									<div class="hmf-w-100">
										<div class="hmf-mx-0 hmf-mx-md-auto hmf-p-0 hmf-position-relative">
											<!-- image -->
											<button class="image-container clickable-area hmf-w-100 hmf-display-flex hmf-flex-column" (click)="openQuickviewPanel(product);">
												@if (unavailableImageSkusSet().has(product.skuDetails.partNumber)) {
													<shared-media-component-optimized-image
														[imageLoaderConfig]="unavailableImageConfig"
														[altText]="`${product.skuDetails.name} ${product.imageLoaderConfig.loaderParams.swatchColor ?? 'default'} thumbnail`"
													></shared-media-component-optimized-image>
												}
												@else {
													<shared-media-component-optimized-image
														[imageLoaderConfig]="product.imageLoaderConfig"
														[altText]="`${product.skuDetails.name} ${product.imageLoaderConfig.loaderParams.swatchColor ?? 'default'} thumbnail`"
														(handleError)="handleImageError(product.skuDetails.partNumber)"
													></shared-media-component-optimized-image>
												}
											</button>
											@if ($index === 0) {
												<div class="badge">
													<hmf-badge badgeName="ViewingItem"/>
												</div>
											}
										</div>
									</div>
									<div class="individual-card-container-description">
										<button class="individual-card-container-title clickable-area hmf-body-m hmf-mt-xxs hmf-mt-m-xs hmf-mb-xxxs"
											 (click)="openQuickviewPanel(product);">
											{{ product.skuDetails.name }}
										</button>
										<div class="hmf-body-bold-m hmf-body-bold-m-l hmf-mb-xxxs hmf-mb-m-xxs">
											@if (product.prices.emptyPrice) {
												<div>See Price In Cart</div>
											} @else {
												<div>
													<span>{{ product.prices.minOfferPrice | currency }}</span>
													@if (product.prices.maxOfferPrice > product.prices.minOfferPrice) {
														<span> - {{ product.prices.maxOfferPrice | currency }}</span>
													}
												</div>
											}
										</div>
										<!-- Show PDP product's color if sku is unresolved -->
										@if ($index === 0 && !resolvedSku() && pdpProductColor()) {
											<button hmf-action-text
													[variant]="'tertiary'"
													[size]="attributeButtonSize()"
													(click)="openQuickviewPanel(product);">
												{{ pdpProductColor() }}
											</button>
										} @else if (attributeDisplayTexts()[$index]) {
											<button hmf-action-text
													[variant]="'tertiary'"
													[size]="attributeButtonSize()"
													(click)="openQuickviewPanel(product);">
												{{ attributeDisplayTexts()[$index] }}
											</button>
										} @else {
											<div class="hmf-p-xxs"></div>
										}
									</div>
									<div class="hmf-display-xs-flex hmf-display-md-none">
										<button
											hmf-button
											class="hmf-w-100 hmf-mx-0 hmf-mt-xs hmf-mt-m-s hmf-text-align-center"
											[variant]="'secondary'"
											[text]="'Add'"
											[size]="'medium'"
											[loading]="false"
											[disabled]="false"
											[label]="'Add'"
											[icon]="'order-cart-standard'"
											(click)="openQuickviewPanel(product);">
										</button>
									</div>
									<div class="hmf-display-none hmf-display-md-flex">
										<button
											hmf-button
											id="fbt-add-to-cart-root-product"
											class="hmf-w-100 hmf-mx-0 hmf-mt-xs hmf-mt-m-s"
											[variant]="'secondary'"
											[text]="atcButtonTexts.atc"
											[size]="'medium'"
											[loading]="false"
											[disabled]="false"
											[label]="atcButtonTexts.atc"
											[icon]="'order-cart-standard'"
											(click)="openQuickviewPanel(product);">
										</button>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
